import "./styles.scss";
import $ from 'jquery';

$(document).ready(function () {

    $('.close-btn').click(function () {
        $('.hero-flexslider-wrapper').animate({'left': '-380'});
        $('.hotspot-wrapper a').removeClass('selected');
        $('.hotspot-wrapper').addClass('rotating');
    })
    $('.hotspot-wrapper .image-container a').click(function () {
        $('.hotspot-wrapper a').removeClass('selected');
        $(this).addClass('selected');
        var hotspot = $(this).attr('rel');
        var index = $('#' + hotspot).index();
        $('.hero-flexslider').flexslider(index);
        if ($('.hotspot-wrapper').hasClass('rotating')) {
            $('.hotspot-wrapper').removeClass('rotating');  /* missing . before removeClass */
        }

    });

    $('.hero-flexslider').flexslider({
        animation: "slide",
        animationLoop: false,
        slideshow: false,
        maxItems: 1,
        minItems: 1,
        after: function (slider) {
            $('.hotspot-wrapper .image-container a.selected').removeClass('selected');
            $('.hotspot-wrapper .image-container a[rel=hotspot' + (slider.currentSlide + 1) + ']').addClass('selected');
        },
    });

    if (window.innerWidth < 900) {
        $('.table-slider').flexslider({
            animation: "slide",
            animationLoop: false,
            minItems: 1,
            maxItems: 1,
        });
    }
    if (window.innerWidth < 750) {
        $('.flexslider-desc').flexslider({
            animation: "slide",
            animationLoop: false,
            slideshow: false
        });
    }

    if ($(window).width() > 750 && $(window).width() < 1200) {
        function height() {
            let textHeight = $('.flexslider-desc .desc2 .img-desc').outerHeight() + 34;
            let containerHeight = $('.hero-container').outerHeight();
            let imgHeight = containerHeight - textHeight
            $('.bg-img-desktop2').css('height', imgHeight);
        }
        setTimeout(height, 150);
    }

    $(window).on('resize', function () {
        setTimeout(() => {AOS.refresh();}, 500);
        function flexdestroy(selector) {
            var el = $(selector);
            var elClean = el.clone();

            elClean.find('.flex-viewport').children().unwrap();
            elClean
                .removeClass('flexslider')
                .find('.clone, .flex-direction-nav, .flex-control-nav')
                .remove()
                .end()
                .find('*').removeAttr('style').removeClass (function (index, css) {
                return (css.match (/\bflex\S+/g) || []).join(' ');
            });

            elClean.insertBefore(el);
            el.remove();
        }
        if ($(window).width() <= 900) {
            $('.table-slider').flexslider({
                animation: "slide",
                animationLoop: false,
                initDelay: 500,
                minItems: 1,
                maxItems: 1,
                start: function(slider){
                    window.flexslider = slider;
                }
            });
        } else{
            flexdestroy('.table-slider');
        }
        if ($(window).width() <= 750) {
            $('.flexslider-desc').flexslider({
                animation: "slide",
                animationLoop: false,
                slideshow: false
            });
        } else{
            flexdestroy('.flexslider-desc');
        }
        if ($(window).width() > 750 ){
            let textHeight = $('.flexslider-desc .desc2 .img-desc').outerHeight() + 34;
            let containerHeight = $('.hero-container').outerHeight();
            let imgHeight = containerHeight - textHeight
            $('.bg-img-desktop2').css('height', imgHeight);
            $('.bg-img-desktop2').css('width', imgHeight * 444 / 1085);
        }
    });

    setTimeout(() => {AOS.refresh();}, 500);
});


